export default __webpack_public_path__ + "static/media/Blog3_4.97e6d317.jpg";